/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddMedicinesToPrescriptionOrderRequestDto,
  ErrorResponse,
  GetMedicinesInPrescriptionOrder200Response,
} from '../models/index';
import {
    AddMedicinesToPrescriptionOrderRequestDtoFromJSON,
    AddMedicinesToPrescriptionOrderRequestDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetMedicinesInPrescriptionOrder200ResponseFromJSON,
    GetMedicinesInPrescriptionOrder200ResponseToJSON,
} from '../models/index';

export interface AddMedicinesToPrescriptionOrderRequest {
    prescriptionId: string;
    addMedicinesToPrescriptionOrderRequestDto: AddMedicinesToPrescriptionOrderRequestDto;
}

export interface GetMedicinesInPrescriptionOrderRequest {
    prescriptionId: string;
}

export interface RemoveMedicineFromPrescriptionOrderRequest {
    prescriptionId: string;
    medicineId: string;
}

/**
 * 
 */
export class MedicineProviderApi extends runtime.BaseAPI {

    /**
     * Adds medicines to a prescription order by creating or updating a prescription order with medicine IDs
     * Add medicines to prescription order
     */
    async addMedicinesToPrescriptionOrderRaw(requestParameters: AddMedicinesToPrescriptionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling addMedicinesToPrescriptionOrder().'
            );
        }

        if (requestParameters['addMedicinesToPrescriptionOrderRequestDto'] == null) {
            throw new runtime.RequiredError(
                'addMedicinesToPrescriptionOrderRequestDto',
                'Required parameter "addMedicinesToPrescriptionOrderRequestDto" was null or undefined when calling addMedicinesToPrescriptionOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/medicines/{prescriptionId}/medicines`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddMedicinesToPrescriptionOrderRequestDtoToJSON(requestParameters['addMedicinesToPrescriptionOrderRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Adds medicines to a prescription order by creating or updating a prescription order with medicine IDs
     * Add medicines to prescription order
     */
    async addMedicinesToPrescriptionOrder(requestParameters: AddMedicinesToPrescriptionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.addMedicinesToPrescriptionOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all medicines in a prescription order
     * Get medicines in prescription order
     */
    async getMedicinesInPrescriptionOrderRaw(requestParameters: GetMedicinesInPrescriptionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMedicinesInPrescriptionOrder200Response>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling getMedicinesInPrescriptionOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/medicines/{prescriptionId}/medicines`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMedicinesInPrescriptionOrder200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all medicines in a prescription order
     * Get medicines in prescription order
     */
    async getMedicinesInPrescriptionOrder(requestParameters: GetMedicinesInPrescriptionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMedicinesInPrescriptionOrder200Response> {
        const response = await this.getMedicinesInPrescriptionOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a medicine from a prescription order
     * Remove medicine from prescription order
     */
    async removeMedicineFromPrescriptionOrderRaw(requestParameters: RemoveMedicineFromPrescriptionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling removeMedicineFromPrescriptionOrder().'
            );
        }

        if (requestParameters['medicineId'] == null) {
            throw new runtime.RequiredError(
                'medicineId',
                'Required parameter "medicineId" was null or undefined when calling removeMedicineFromPrescriptionOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/medicines/{prescriptionId}/medicines/{medicineId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))).replace(`{${"medicineId"}}`, encodeURIComponent(String(requestParameters['medicineId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Removes a medicine from a prescription order
     * Remove medicine from prescription order
     */
    async removeMedicineFromPrescriptionOrder(requestParameters: RemoveMedicineFromPrescriptionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.removeMedicineFromPrescriptionOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
